/**
 * Assets "Payload (T)": parsing, suggested values, and whether a payload has a
 * tonnage class in the cost tables.
 */

import { normaliseTonnageClass } from './costRateBasis';

/** The empty-cell placeholder older Assets rows store (data, not UI text). */
const EMPTY_CELL_PLACEHOLDER = '\u2014';

export function parseTypicalTonnes(s: string): string {
  const raw = String(s ?? '').trim().replace(/t+$/i, '');
  if (!raw || raw === EMPTY_CELL_PLACEHOLDER) return '';
  const match = raw.match(/\d+(?:\.\d*)?/);
  return match ? match[0] : '';
}

/**
 * Suggested payloads: the tonnage classes the client runs (3.5T, 7.5T, 18T,
 * 44T = Artic). Not 26T: the client has no 26T vehicles. Users can still type
 * any value, and one already on the roster is still suggested.
 */
export const STANDARD_PAYLOAD_TONNES = ['3.5', '7.5', '18', '44'] as const;

/** Standard payloads plus any other value already on the roster, in numeric order. */
export function payloadTonnesSuggestions(rows: ReadonlyArray<{ typical_tonnes?: string | number }>): string[] {
  const values = new Set<string>(STANDARD_PAYLOAD_TONNES);
  for (const row of rows) {
    const v = parseTypicalTonnes(String(row.typical_tonnes ?? ''));
    if (v) values.add(v);
  }
  return [...values].sort((a, b) => Number(a) - Number(b));
}

/** A payload with no tonnage class is costed at the Default class rates. */
export function payloadCostedAsDefault(value: unknown): boolean {
  const v = parseTypicalTonnes(String(value ?? ''));
  return v !== '' && normaliseTonnageClass(v) === 'Default';
}

export const PAYLOAD_OPTIONS_LIST_ID = 'asset-payload-tonnes-options';
